import MyAccountInvoicePage from './MyAccountInvoicePage'

export default MyAccountInvoicePage
// eslint-disable-next-line import/export
export * from './MyAccountInvoicePage'
